var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from "vue-facing-decorator";
import { CompaniesClient, CompanySystemOverviewModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
const companiesClient = new CompaniesClient(window.apiUrl);
const maxNumberOfItems = 100;
let CompanySystemOverviewVuew = class CompanySystemOverviewVuew extends Vue {
    constructor() {
        super(...arguments);
        this.data = new CompanySystemOverviewModel();
    }
    created() {
        this.get();
    }
    ;
    get() {
        if (!this.companyId)
            return;
        companiesClient
            .getSystemOverview(this.companyId)
            .then(response => {
            if (!response)
                return;
            this.data = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    // computed
    get numberOfSystems() {
        return TextHelper.formatNumericStatusField(this.data.totalNumberOfSystems, maxNumberOfItems);
    }
    ;
    get numberOfHealthySystems() {
        return TextHelper.formatNumericStatusField(this.data.totalNumberOfHealthySystems, maxNumberOfItems);
    }
    ;
    get numberOfCriticalSystems() {
        return TextHelper.formatNumericStatusField(this.data.totalNumberOfCriticalSystems, maxNumberOfItems);
    }
    ;
    get numberOfWarningSystems() {
        return TextHelper.formatNumericStatusField(this.data.totalNumberOfWarningSystems, maxNumberOfItems);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySystemOverviewVuew.prototype, "companyId", void 0);
CompanySystemOverviewVuew = __decorate([
    Component({
        name: "CompanySystemOverviewVue"
    })
], CompanySystemOverviewVuew);
export default CompanySystemOverviewVuew;
